<template>
  <div class="d-flex flex-column">
    <b-table
      id="employee-monthly-attendance-pdf-table"
      ref="employee-monthly-attendance-pdf-table"
      table-class="table-head-custom table-vertical-center"
      :responsive="true"
      hover
      :fields="fields"
      :items="items"
      :busy="isBusy"
      show-empty
    >
      <!-- begin:header template    -->
      <template v-slot:head(index)="data">
        <span class="text-dark-75">{{ data.label.toUpperCase() }}</span>
      </template>
      <!-- end:header template    -->

      <!-- begin: cell templates      -->
      <template v-slot:cell(index)="data">
        <span class="font-weight-bolder">
          {{ data.index + 1 }}
        </span>
      </template>

      <template v-slot:cell(employee)="data">
        <CommonEmployeeSummary :item="data.item"></CommonEmployeeSummary>
      </template>

      <template v-slot:cell(present)="data">
        {{ data.item.present_count }}
      </template>

      <template v-slot:cell(absent)="data">
        {{ data.item.absent_count }}
      </template>

      <template v-slot:cell(leave)="data">
        {{ data.item.leave_count }}
      </template>

      <template v-slot:cell(away)="data">
        {{ data.item.away_count }}
      </template>

      <template v-slot:cell(holiday)="data">
        {{ data.item.holiday_count }}
      </template>

      <template v-slot:cell(offdays)="data">
        {{ data.item.offdays_count }}
      </template>

      <!-- end: cell templates      -->

      <template #table-busy>
        <AppLoader></AppLoader>
      </template>
    </b-table>

    <div class="d-flex justify-content-end" v-if="items.length">
      <b-pagination
        pills
        size="lg"
        class="pt-5"
        @change="$emit('changePage', $event)"
        v-model="pagination.current_page"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        aria-controls="employee-monthly-attendance-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import i18n from "@/core/plugins/vue-i18n";
import CommonEmployeeSummary from "@/modules/core/components/company/CommonEmployeeSummary";
import AppLoader from "@/modules/core/components/loaders/AppLoader";
export default {
  name: "AttendancePdfTable",
  components: {
    AppLoader,
    CommonEmployeeSummary,
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: Array,
    },
    pagination: {
      type: Object,
      required: true,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: [
        { key: "index", label: "#" },
        { key: "employee", label: i18n.t("EMPLOYEE.HEADER") },
        { key: "present", label: "Present" },
        { key: "absent", label: "Absent" },
        { key: "leave", label: "On Leave" },
        { key: "away", label: "Away" },
        { key: "holiday", label: "Holiday" },
        { key: "offdays", label: "Offday" },
      ],
    };
  },
};
</script>

<style scoped></style>
